<template>
  <div class="gkmg-port-master-dialog-bit-input">
    <div
      v-show="typeof valueMap.itSelf === 'string'"
      class="flex justify-center"
    >
      <span class="text-before-change max-w-full">
        変更前 : {{ valueMap.itSelf }}
      </span>
    </div>

    <div class="flex justify-center">
      <input class="input" v-model="inputValueLeft" />
      <span class="text-between-input">〜</span>
      <input class="input" v-model="inputValueRight" />
    </div>

    <div class="flex justify-center">
      <vs-button class="button" color="#2E87B9" @mousedown="closePopup">
        <span class="button-text">キャンセル</span>
      </vs-button>
      <vs-button
        class="button"
        color="#2E87B0"
        v-bind:disabled="activated()"
        @mousedown="onSubmit(isUpdateTimeStamp)"
      >
        <span class="button-text">保存</span>
      </vs-button>
    </div>
  </div>
</template>

<script>
/*
 * 入出港予定一覧画面（白色ではなく黒色画面）のセル編集にあたり、テキスト編集をする場合のためのコンポーネント
 * @parent CellSummaryDialog.vue
 * @props taskId: String 一覧画面で表示する一行のデータにふられたID
 *        columnKey: String カラム名を特定するためのキー。const.jsのCOL_NAMEの中の、columnKey
 *        valueMap : String 現在表示されている値。
 *        closePopup: ポップアップを閉じる関数。
 */
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("gkmgPortMasterDestinationWork");
import moment from "moment-timezone";

export default {
  name: "O.DialogBitInput",
  props: {
    taskId: { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap: { type: Object, required: true },
    closePopup: { type: Function, required: true },
  },
  data() {
    return {
      inputValueLeft: "",
      inputValueRight: "",
      isUpdateTimeStamp: null,
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if (this.summaryDialogShowPopup === true) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: (state) => state.masterMap,
      summaryDialogShowPopup: (state) => state.summaryDialogShowPopup,
    }),
    enableSave() {
      return true;
    },
  },
  methods: {
    initData() {
      this.inputValueLeft = this.valueMap.left ? this.valueMap.left : "";
      this.inputValueRight = this.valueMap.right ? this.valueMap.right : "";
      this.isUpdateTimeStamp =
        this.inputValueLeft ||
        this.inputValueRight ||
        (this.valueMap.changes && this.valueMap.changes[String(this.columnKey)])
          ? true
          : false;
    },
    onSubmit(isUpdateTimeStamp) {
      /*
       * onSubmit(false)    : 保存
       * onSubmit(true)     : ハイライト保存
       */
      let mode = [];
      if (isUpdateTimeStamp) mode.push("updateTimeStamp");
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey + "#left"] = this.inputValueLeft
        ? this.inputValueLeft
        : null;
      updateKeyValueMap[this.columnKey + "#right"] = this.inputValueRight
        ? this.inputValueRight
        : null;
      updateKeyValueMap["updated_at"] = new Date(
        moment().local().format("YYYY-MM-DD HH:mm:ss"),
      );
      this.$emit("updateValue", this.taskId, updateKeyValueMap, mode);
    },
    activated() {
      if (this.inputValueLeft && this.inputValueRight) {
        return false;
      } else {
        return true;
      }
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style scoped lang="scss">
.gkmg-port-master-dialog-bit-input {
  .text-before-change {
    /* text */

    width: 761px;
    height: 24px;

    font-family: "Hiragino Kaku Gothic Pro";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height */
    display: flex;
    align-items: center;
    text-align: center;

    color: #4f4f4f;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  .input {
    width: 100px;
    border-radius: 8px;
    padding: 16px;
    margin: 16px;
    gap: 8px;

    font-family: "Hiragino Kaku Gothic Pro";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #4f4f4f;
    background-color: #bcbcbc;
    border: none;
  }

  .text-between-input {
    width: 20px;
    align-items: center;
    margin: 32px;

    font-family: "Hiragino Kaku Gothic Pro";
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    color: #4f4f4f;
  }

  .button {
    width: 230px;
    height: 46px;
    margin: 0 1rem;
    border-radius: 8px;
    cursor: pointer;
  }
  .button-text {
    width: 32px;
    height: 24px;

    font-family: "Hiragino Kaku Gothic Pro";
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    /* identical to box height */
    align-items: center;
    text-align: center;

    color: #f2f2f2;
  }
}
</style>
